import { useEffect, useState } from "react";
import { useContext } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import dataContext from "./context/dataContext";
import mainContext from "./context/mainContext";
import {
  AssessmentStart,
  CameraFace,
  Comprehension,
  ComprehensionTest,
} from "./pages/Assessments";
import { Dashboard, Instructions, Result } from "./pages/commonPages";
import { FSTraining } from "./pages/Freestyle";
import { ChangePassword, ContactUs, Setting } from "./pages/Settings";
import InputClassroomId from "./pages/Signup/InputClassroomId/InputClassroomId";
import { CalibrateCam, Exercise, StartFocus } from "./pages/TrainFocus";
import {
  BookInfo,
  PushUpInstructions,
  ExerciseResult,
  PushUpTimer2,
} from "./pages/TrainReading";
import {
  Questions,
  LevelExercise,
  ExerciseClock,
  ExerciseQuestion,
  ExerciseRate,
} from "./pages/TrainReading";
import userRequests from "./components/api/userRequests";
import UmooveApi from "./components/api/UmooveApi";
// import PushUpTimer from "./pages/TrainReading/Timer";
let historyi = []
export default function Main() {
  let { nav, header } = useContext(mainContext);
  const [historyArray, setHistoryArray] = useState([])
  let { userDetails, setAssessmentId } = useContext(dataContext);
  const navigate = useNavigate();
  const location = useLocation()
  useEffect(() => {
    if (!userDetails?.classId) {
      setTimeout(() => navigate("/setClassId", { replace: true }), 350);
    } else {
      // if (!userDetails?.assessments.length > 0) {
      //   userRequests.checkForNewAssessment().then(data => {
      //     setAssessmentId(prev => {
      //       return data.data
      //     })
      //     navigate("assessments", { replace: true });

      //   }).catch(err => console.log(err))
      // }
    }

  }, [userDetails]);
  const backHandler = (event) => { // Listen for back button press
    let loc = { ...location };
    // event.preventDefault();
    console.log("🚀 ~ useEffect ~ location.pathname === ", location.pathname);
    console.log("🚀 ~ useEffect ~ location.pathname === ", loc.state);
    if (loc.pathname === "/" && loc.state === "press-back") { // If on home page and state is "press-back"
      // Perform action to exit the page
      // For example, you can close the window/tab
      window.close(); // Close the window/tab
    } else { // If not on home page
      navigate("/", { state: "press-back", replace: false }); // Navigate to home page with state "press-back"
      UmooveApi.API_stopUmoove().then(() => { // Stop Umoove API

      });
    }
    if (historyArray.length > 2) {
      if (historyArray[historyArray.length - 1] !== historyArray[0]) {
        navigate("/", { state: "press-back" }); // Navigate to home page with state "press-back"
        UmooveApi.API_stopUmoove().then(() => { }) // Stop Umoove API
      } else if (historyArray[historyArray.length - 1] == historyArray[0]) {
        // alert("cccc")
        navigate("/", { state: "press-back" }); // Navigate to home page with state "press-back"
        window.close()
      };
    }
  }
  useEffect(() => {
    header.setIsShowHeader(true); // Show header
    if (window.buildType == "android") {
      window.onpopstate = backHandler;
    }
  }, []);
  useEffect(() => {
    if (window.buildType == "android") {
      return;
    }
    // console.table(historyi);
    let currentNavEntries = window.navigation;
    // historyi.push(window.history)
    setHistoryArray(prev => {
      let newArr = prev
      newArr.push(currentNavEntries?.currentEntry?.url)
      console.log(newArr);
      return newArr
    })

    // if (location.state == "press-back" && location.pathname == "/") {
    //   alert(34)
    //   window.close()
    // }
    // Your other logic here...
  }, [location]);

  // useEffect(() => {
  //   if (historyArray.length > 4) {
  //     if (historyArray[historyArray.length - 1] == historyArray[historyArray.length - 3]) {
  //       console.log("vsffffffffffffffffffffffffffffffffffffffffffff")
  //       alert("nne")
  //     }
  //   }
  // }, [historyArray])

  return (
    <>
      <Routes>
        {/* dashboard - yosef */}
        <Route path="/setClassId" element={<InputClassroomId />} />

        <Route index element={<Dashboard />} />
        <Route path="contact-us" element={<ContactUs />} />

        {/* assesment roll - yosef */}
        <Route path="assessments">
          <Route index element={<Instructions title="Measurement Instruction" textList={["Watch the explanatory video and follow the instructions"]} navigateTo="/assessments/start" iframe={<iframe src="https://www.youtube.com/embed/H4e0uOQ87cI?autoplay=0&mute=0&rel=0&color=white&controls=1&disablekb=1&playsinline=1" width="100%" height="400" title="Fully Focused Learning's ReadMate App: Reading Rate Comprehension & Standard Deviation Demo Video" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>} />} />
          <Route path="start" element={<AssessmentStart />} />
          <Route path="camera-face" element={<CameraFace />} />
          <Route path="comprehension" element={<Comprehension />} />
          <Route path="comprehension-Test" element={<ComprehensionTest />} />
          <Route path="result" element={<Result from="assessments" />} />
        </Route>

        {/* train-focus roll - yosef */}
        <Route path="train-focus">
          <Route index element={<Instructions title="Near-Point Instruction" textList={["Watch the explanatory video and follow the instructions"]} navigateTo="/train-focus/calibrate-cam" iframe={<iframe src="https://www.youtube.com/embed/jkr6qRDDp40?autoplay=0&mute=0&rel=0&color=white&controls=1&disablekb=1&playsinline=1" width="100%" height="400" title="Fully Focused Learning's ReadMate App: Reading Rate Comprehension & Standard Deviation Demo Video" frameborder="0" allowfullscreen></iframe>} />} />
          <Route path="calibrate-cam" element={<CalibrateCam />} />
          <Route path="start-focus" element={<StartFocus />} />
          <Route path="exercise" element={<Exercise />} />
          <Route path="result" element={<Result from="train-focus" />} />
        </Route>

        {/* train-reading roll - yosef */}
        <Route path="/train-reading">
          <Route index element={<Instructions title="PUSHUP INSTRUCTION" textList={["Watch the explanatory video and follow the instructions"]} navigateTo="/train-reading/book-info" iframe={<iframe src="https://www.youtube.com/embed/nkEDT80IAiM?autoplay=0&mute=0&rel=0&color=white&controls=1&disablekb=1&playsinline=1" width="100%" height="400" title="Fully Focused Learning's ReadMate App: Reading Rate Comprehension & Standard Deviation Demo Video" frameBorder="0" allowfullscreen></iframe>} />} />
          <Route path="book-info" element={<BookInfo />} />
          <Route path="pushup" element={<PushUpInstructions />} />
          <Route path="timer" element={<PushUpTimer2 />} />
          <Route path="questions" element={<Questions />} />
          <Route path="level-exercise" element={<LevelExercise />} />
          <Route path="exercise-clock" element={<ExerciseClock />} />
          <Route path="rate" element={<ExerciseRate />} />
          <Route path="question" element={<ExerciseQuestion />} />
          <Route path="result" element={<ExerciseResult />} />
        </Route>

        {/* settings roll - yosef */}
        <Route path="settings">
          <Route index element={<Setting />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>

        {/* freestyle roll - yosef */}
        <Route path="freestyle">
          <Route index element={<BookInfo from={"freestyle"} />} />
          <Route path="set-rate" element={<FSTraining />} />
        </Route>
      </Routes>
    </>
  );
}
